import { isDate } from 'date-fns';
import isEmpty from 'lodash-es/isEmpty';

import { isValidPhone } from '@ecp/common/src/utils/InputValidateUtils';
import { DEFAULT_PRICE_FORMAT } from '@ecp/common/src/const/price/priceConst';

export const SITE_STATUS_TYPE_CD = 'ST1006';
export const SITE_OPERATION_TYPE_CD = 'ST1007';
export const SITE_TYPE_CD = 'ST1002';
export const SETTLE_TYPE_CD = 'SA1001';
export const MEMBER_ENTRY_MEAN_CD = 'ST1004';
export const SETTLE_STD_CD = 'PV0066';
export const PAY_MEAN_CD = 'OD0005';
export const KAKAO_PULS_CD = 'ST0039';

export const SETTING = '20';
export const TEMP_SAVE = '30';
export const RUNNING = '10';
export const TERMINATED = '40';

export const SITE_STATUS = {
  ['10']: '서비스중',
  ['20']: '셋팅중',
  ['30']: '임시저장',
  ['40']: '종료',
};

export const SUPER_MANAGER = '001';

export const contractPeriods = [
  { name: '오늘', value: '1-days' },
  { name: '1주일', value: '1-weeks' },
  { name: '15일', value: '15-days' },
  { name: '1개월', value: '1-months' },
  { name: '3개월', value: '3-months' },
  { name: '6개월', value: '6-months' },
  { name: '1년', value: '12-months' },
  { name: '전체', value: 'all' },
];

export const contractPeriodType = [
  { label: '시작일', value: 'start', key: 'start' },
  {
    label: '종료일',
    value: 'end',
    key: 'end',
  },
];

export const keywordOptions = [
  { label: '사이트번호', key: 'siteNumberList' },
  { label: '사이트명', key: 'siteNameList' },
  { label: '고객사명', key: 'clientNameList' },
];

export const initialForm = {
  siteNumber: '',
  keyword: { type: 'siteNumberList', value: '' },
  siteStatus: [],
  siteType: [],
  siteOperationType: [],
  contractPeriodType: contractPeriodType[0],
  settleType: { key: 'ALL', value: 'ALL', label: '전체' },
  contract: { from: '', to: '', period: contractPeriods[7] },
};

export const initialDetailState = {
  siteName: '',
  siteTypeCode: '10',
  siteOperationCode: '10',
  availableStartDate: '',
  availableEndDate: '',
  recvDsagArsTel: '',
  recvDsagArsUseYn: 'N',
  siteInquiryJobGroupList: [],
  siteMobileUrl: '',
  sitePcUrl: '',
  redirectUrlList: [''],
  clientName: '',
  customerBusinessNumber: '',
  clientRepresentativeTel: '',
  clientRepresentativeName: '',
  memberAdditionalInfoInputYn: 'N',
  subsidiaryList: [{ subsidiaryCompanyName: '', subsidiaryCompanyCode: '자동채번', newItem: true }],
  memberEntryMeanCode: '10',
  memberEntryBtnYn: 'Y',
  memberGenderInputYn: 'N',
  bizpMemberYn: 'N',
  eventUseYn: 'N',
  siteSettleDivisionCode: { key: '', label: '' },
  siteAutoSettleYn: 'Y',
  siteStandardSettleYn: 'Y',
  settleStandardCode: { key: '', label: '' },
  reserveUseYn: 'Y',
  couponUseYn: 'Y',
  couponMenuExpsYn: 'Y',
  pointUseYn: 'Y',
  otoQuestUseYn: 'Y',
  bestSkwdCollectionName: '',
  bestSkwdCollectionUseYn: 'Y',
  bulkOrdMenuUseYn: 'Y',
  memberGradeUseYn: 'N',
  siteDesc: '',
  mktingUseYn: 'N',
  pntExpsNm: '웰포인트',
  cartUseYn: 'Y',
  goodCardCartBtnUseYn: 'Y',
  priceExpsUseYn: 'Y',
  siteApplyExceptPayMeanList: [],
  orderConfirmAutoExceptYn: 'N',
  noMemberUseYn: 'N',
  theme: 'default',
  kakaoChannelCode: { key: '', label: '' },
  usePriceFormat: 'N',
  // 가격 단위 (마일리지, 포인트 등)
  priceFormat: DEFAULT_PRICE_FORMAT,
  usePriceFormatPerKrw: 'N',
  // 금액 환산 비율 (?원당 1 가격단위)
  priceFormatPerKrw: 1,
};

export const initialDetailError = {
  siteName: undefined,
  availableStartDate: undefined,
  availableEndDate: undefined,
  recvDsagArsTel: undefined,
  recvDsagArsUseYn: undefined,
  clientName: undefined,
  customerBusinessNumber: undefined,
  clientRepresentativeTel: undefined,
  clientRepresentativeName: undefined,
  subsidiaryList: undefined,
  siteMobileUrl: undefined,
  sitePcUrl: undefined,
  siteSettleDivisionCode: undefined,
};

export const formValidators = {
  siteName: [
    {
      when: ['created', 'updated'],
      message: '사이트명을 입력해주세요.',
      validator: ({ siteName }) => !isEmpty(siteName),
    },
  ],
  availableStartDate: [
    {
      when: ['created', 'updated'],
      message: '계약기간 시작일을 입력해주세요.',
      validator: ({ availableStartDate }) => isDate(availableStartDate),
    },
  ],
  availableEndDate: [
    {
      when: ['created', 'updated'],
      message: '계약기간 종료일을 입력해주세요.',
      validator: ({ availableEndDate }) => isDate(availableEndDate),
    },
  ],
  recvDsagArsTel: [
    {
      when: ['created', 'updated'],
      message: '수신거부ARS전화번호를 입력해주세요.',
      validator: ({ recvDsagArsUseYn, recvDsagArsTel }) => {
        if (recvDsagArsUseYn === 'Y') {
          return !isEmpty(recvDsagArsTel);
        }
        return true;
      },
    },
    {
      when: ['created', 'updated'],
      message: '유형에 맞게 입력해주세요.',
      validator: ({ recvDsagArsUseYn, recvDsagArsTel }) => {
        if (recvDsagArsUseYn === 'Y') {
          const regTel = /^[0-9]+$/;
          return regTel.test(recvDsagArsTel);
        }
        return true;
      },
    },
  ],
  clientName: [
    {
      when: ['created', 'updated'],
      message: '고객사명을 입력해주세요.',
      validator: ({ clientName }) => !isEmpty(clientName),
    },
  ],
  customerBusinessNumber: [
    {
      when: ['created', 'updated'],
      message: '유형에 맞게 입력해주세요.',
      validator: ({ customerBusinessNumber }) => {
        if (!customerBusinessNumber) return true;

        const regPhone = /^[0-9-]+$/;
        return regPhone.test(customerBusinessNumber);
      },
    },
  ],
  clientRepresentativeTel: [
    {
      when: ['created', 'updated'],
      message: '전화번호 유형에 맞게 입력해주세요.',
      validator: ({ clientRepresentativeTel }) => !clientRepresentativeTel || isValidPhone(clientRepresentativeTel),
    },
  ],
  clientRepresentativeName: [
    {
      when: ['created', 'updated'],
      message: '대표자명을 입력해주세요.',
      validator: ({ clientRepresentativeName }) => !isEmpty(clientRepresentativeName),
    },
  ],
  subsidiaryList: [
    {
      when: ['created', 'updated'],
      message: '계열사명을 입력해주세요.',
      validator: ({ subsidiaryList }) =>
        subsidiaryList.every(({ subsidiaryCompanyName }) => !isEmpty(subsidiaryCompanyName)),
    },
  ],
  siteMobileUrl: [
    {
      when: ['created', 'updated'],
      message: 'Mobile 도메인을 입력해주세요.',
      validator: ({ siteMobileUrl }) => !isEmpty(siteMobileUrl),
    },
    {
      when: ['created', 'updated'],
      message: 'https:// 로 시작해야 합니다.',
      validator: ({ siteMobileUrl }) => siteMobileUrl.startsWith('https://'),
    },
    {
      when: ['created', 'updated'],
      message: '/ 로 끝날수 없습니다.',
      validator: ({ siteMobileUrl }) => !siteMobileUrl.endsWith('/'),
    },
  ],
  sitePcUrl: [
    {
      when: ['created', 'updated'],
      message: 'PC 도메인을 입력해주세요.',
      validator: ({ sitePcUrl }) => !isEmpty(sitePcUrl),
    },
    {
      when: ['created', 'updated'],
      message: 'https:// 로 시작해야 합니다.',
      validator: ({ sitePcUrl }) => sitePcUrl.startsWith('https://'),
    },
    {
      when: ['created', 'updated'],
      message: '/ 로 끝날수 없습니다.',
      validator: ({ sitePcUrl }) => !sitePcUrl.endsWith('/'),
    },
  ],
  siteSettleDivisionCode: [
    {
      when: ['created', 'updated'],
      message: '정산구분 값을 입력해주세요.',
      validator: ({ siteSettleDivisionCode }) => !isEmpty(siteSettleDivisionCode),
    },
  ],
  pntExpsNm: [
    {
      when: ['created', 'updated'],
      message: '복지포인트 명칭을 입력해주세요.',
      validator: ({ pntExpsNm }) => !isEmpty(pntExpsNm),
    },
  ],
};
